import { SvgLogo } from '@obvio/svg'
import { UserPanelWishlist } from '@obvio/template'

import type { ReactElement } from 'react'

function Orders(): ReactElement {
  return <UserPanelWishlist logo={SvgLogo} />
}

export default Orders
